import { useCallback, useEffect, useRef, useState } from 'react';

import { getTeacherClassManagementConfig } from '../../../../api/requests/settings';
import { TeacherClassManagementConfig } from '../interfaces/teacher-class-management.interface';

export const useTeacherClassManagementConfig = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isRefetching, setIsRefetching] = useState(false);
  const alreadyFetched = useRef(false);

  const [config, setConfig] = useState<TeacherClassManagementConfig | null>();
  const [error, setError] = useState(false);

  const fetchConfig = useCallback(async () => {
    if (alreadyFetched.current) {
      setIsRefetching(true);
    } else {
      alreadyFetched.current = true;
    }

    const { data, error: fetchError } = await getTeacherClassManagementConfig();

    if (fetchError) {
      setError(true);
    } else {
      setConfig(data);
    }

    setIsLoading(false);
    setIsRefetching(false);
  }, [alreadyFetched]);

  useEffect(() => {
    if (!alreadyFetched.current) {
      fetchConfig();
    }
  }, [fetchConfig]);

  return {
    isLoading,
    config,
    error,
    refetch: fetchConfig,
    isRefetching,
  };
};

export default useTeacherClassManagementConfig;
